import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

const PosterPreview = ({ posterPreviews, handleRemovePoster }) => {
  return (
    <div
      style={{
        width: "120px",
        textAlign: "center",
        position: "relative",
      }}
    >
      <img
        src={posterPreviews.find((poster) => poster.name === "default")?.url}
        alt="Poster preview"
        style={{
          width: "100%",
          objectFit: "cover",
        }}
      />
      {/* <button
        onClick={handleRemovePoster}
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          border: "none",
          backgroundColor: "rgba(255,0,0,0.6)",
          borderRadius: "50%",
          cursor: "pointer",
        }}
      >
        <DeleteIcon style={{ color: "white" }} />
      </button> */}
    </div>
  );
};

export default PosterPreview;
